import * as React from 'react'

const Grayarrow = () => {
  return (
    <svg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2037 2.37051L5.70746 7.17094C5.50763 7.38117 5.17458 7.38117 4.97474 7.17094L0.478488 2.37051C0.278654 2.16027 0.278654 1.80987 0.478487 1.59963L1.21121 0.828763C1.41104 0.618525 1.7441 0.618525 1.94393 0.828763L4.97474 4.12249C5.17458 4.33273 5.50763 4.33273 5.70746 4.12249L8.73827 0.863802C8.9381 0.653564 9.27116 0.653564 9.47099 0.863802L10.2037 1.63467C10.3702 1.84491 10.3702 2.16027 10.2037 2.37051Z'
        fill='gray'
        fillOpacity='0.5'
      />
    </svg>
  )
}
export default Grayarrow



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Grayarrow.tsx